import { P } from 'components'
import { useSnackbar } from 'notistack'
import { useEffect, useRef, useState } from 'react'
import { Info } from 'react-feather'
import { useDispatch, useSelector } from 'react-redux'
import { Button, FormGroup, Input, Modal, ModalBody, Spinner } from 'reactstrap'
import {
  useAddProjectMutation,
  useLazyFindProjectQuery,
  useUpdateProjectMutation,
} from './projectApiSlice'
import { setIsOpenSelectionProject } from './projectSlice'

const ModalAddProject = ({
  isOpen,
  toggle,
  isLoading = false,
  dataAddressBookById = null,
  refetch,
  isOutsideProject = false,
  isPhoneUnRegistered = false,
  isPhoneRegistered = false,
  isEmailUnRegistered = false,
  isEmailRegistered = false,
  isPhoneVerified = false,
  isEmailVerified = false,
  isHarvester = false,
  isLandOwner = false,
}) => {
  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()

  const { searchProject, filledName } = useSelector((s) => s.project)

  const [addProject, { isLoading: isAdding }] = useAddProjectMutation()
  const [updateProject, { isLoading: isUpdating }] = useUpdateProjectMutation()

  const [findProject] = useLazyFindProjectQuery()

  const inputRef = useRef(null)

  const isEditMode = Boolean(dataAddressBookById)

  const [payload, setPayload] = useState({
    label: filledName,
  })

  useEffect(() => {
    if (filledName) {
      setPayload((prevState) => ({ ...prevState, lael: filledName }))
    }
  }, [filledName, payload?.label])

  // FORM VALIDATE
  const isNameEmpty = !payload?.label
  const isFormInvalid = isNameEmpty

  // HANDLE EDIT AND SET VALUE
  useEffect(() => {
    if (isEditMode) {
      setPayload({
        relationName: dataAddressBookById?.label || null,
      })
    } else if (isOutsideProject) {
      setPayload({
        label: searchProject || null,
      })
    } else {
      setPayload({
        label: null,
      })
    }
  }, [dataAddressBookById, isOpen, searchProject])

  // HANDLE CHANGE VALUE
  const handleChange = (e) => {
    const { name, value } = e.target
    setPayload((prev) => ({
      ...prev,
      [name]: value.trim() === '' ? null : value,
    }))
  }

  const handleSubmit = async () => {
    const sanitizedPayload = Object.fromEntries(
      Object.entries(payload).map(([key, value]) => [
        key,
        value === '' ? null : value,
      ]),
    )

    try {
      if (isEditMode) {
        const res = await updateProject({
          id: dataAddressBookById.id,
          ...sanitizedPayload,
        }).unwrap()
        if (!res?.error) {
          enqueueSnackbar('Project berhasil diperbarui!', {
            variant: 'success',
          })
          refetch?.()
          toggle()
          if (isOutsideProject) {
            findProject({
              s: searchProject,
              ...(isPhoneUnRegistered ? { isPhoneUnRegistered: true } : {}),
              ...(isPhoneRegistered ? { isPhoneRegistered: true } : {}),
              ...(isEmailUnRegistered ? { isEmailUnRegistered: true } : {}),
              ...(isEmailRegistered ? { isEmailRegistered: true } : {}),
              ...(isPhoneVerified ? { isPhoneVerified: true } : {}),
              ...(isEmailVerified ? { isEmailVerified: true } : {}),
              ...(isHarvester ? { isHarvester: true } : {}),
              ...(isLandOwner ? { isLandOwner: true } : {}),
            })
            dispatch(setIsOpenSelectionProject(true))
          }
        }
      } else {
        const res = await addProject(sanitizedPayload).unwrap()
        if (!res?.error) {
          enqueueSnackbar('Project berhasil ditambahkan!', {
            variant: 'success',
          })
          refetch?.()
          toggle()
          if (isOutsideProject) {
            findProject({
              s: searchProject,
              ...(isPhoneUnRegistered ? { isPhoneUnRegistered: true } : {}),
              ...(isPhoneRegistered ? { isPhoneRegistered: true } : {}),
              ...(isEmailUnRegistered ? { isEmailUnRegistered: true } : {}),
              ...(isEmailRegistered ? { isEmailRegistered: true } : {}),
            })
            dispatch(setIsOpenSelectionProject(true))
          }
        }
      }
    } catch (error) {
      console.warn(error)
      enqueueSnackbar(
        error?.data?.meta?.message ||
          error?.data?.message ||
          error?.message ||
          'Project gagal diperbarui!',
        {
          variant: 'error',
        },
      )
    }
  }

  // AUTO FOCUS
  useEffect(() => {
    if (isOpen) setTimeout(() => inputRef.current?.focus(), 100)
  }, [isOpen])

  return (
    <>
      <Modal
        className="p-4"
        centered
        isOpen={isOpen}
        toggle={toggle}
        autoFocus={false}
        style={{ maxWidth: '600px' }}
        data-testid="project-modal-add"
      >
        <ModalBody>
          <div className="d-flex flex-column gap-1">
            <P className="text-sm pb-4" size="medium" color="#101828" bold>
              {isEditMode ? 'Edit Project' : 'Tambah Project'}
            </P>

            <div className="pb-3">
              <FormGroup>
                <P className="text-sm pb-1" size="regular" color="#344054">
                  Nama<span style={{ color: '#b42218' }}>*</span>
                </P>
                <Input
                  placeholder="Masukkan nama"
                  name="label"
                  value={payload.label || ''}
                  onChange={handleChange}
                  autoComplete="off"
                  innerRef={inputRef}
                />
              </FormGroup>
            </div>
          </div>

          <div className="d-flex gap-3">
            <Button
              onClick={() => toggle()}
              className="btn-cancel"
              outline
              block
              data-testid="project-modal-add-cancel-button"
            >
              Batal
            </Button>
            <Button
              color="primary"
              block
              disabled={isLoading || isUpdating || isAdding || isFormInvalid}
              onClick={handleSubmit}
              data-testid="project-modal-add-submit-button"
            >
              {(isLoading || isUpdating || isAdding) && (
                <Spinner size="sm" className="me-2" />
              )}
              {isEditMode ? 'Ubah' : 'Tambah'}
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  )
}

export default ModalAddProject
